import { useTranslation } from 'react-i18next';
import { formatCivilRange } from './format';
import { useLocale } from './useLocale';

/**
 * `formatCivilRange` bound to the active locale and the catalog's "from {date}" (TMMRSL-0073): the
 * one way a screen shows a civil range. `dash` is the screen's own missing-value text.
 */
export function useCivilRange(
  dash: string,
): (from: string | null | undefined, to: string | null | undefined) => string {
  const { t } = useTranslation();
  const locale = useLocale();
  return (from, to) =>
    formatCivilRange(from, to, locale, {
      openEnded: (start) => t('common.dateFrom', { date: start }),
      dash,
    });
}
